import FColumnCellMDP from '../FColumnCellMDP';
export default class FCellRouterLinkMDP implements FColumnCellMDP {
    
    componentName: string = "FCellRouterLink";
    routerName: string;
    paramName?: string;
    color?: string;
    icon?: string;
    paramKey?: string;
    paramsList?:Param[];
    fontType?: string;
    label?: string;
    queryList?:Query[];
    constructor(props: {
        routerName: string;
        paramName?:string,
        color?: string;
        icon?: string;
        paramKey?: string;
        paramsList?:Param[];
        fontType?: string;
        label?: string;
        queryList?:Query[];
    }) {
        this.routerName = props.routerName;
        this.paramName = props.paramName;
        this.color = props.color;
        this.icon = props.icon;
        this.paramKey = props.paramKey;
        this.paramsList = props.paramsList;
        this.fontType = props.fontType;
        this.label = props.label;
        this.queryList = props.queryList;

    }
    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                routerName: this.routerName,
                paramName: this.paramName,
                color:this.color,
                icon: this.icon,
                paramKey: this.paramKey,
                paramsList: this.paramsList,
                fontType: this.fontType,
                label: this.label,
                queryList: this.queryList
            }
        }
    }

}

export interface Param {
    paramName: string;
    paramKey: string;
}

export interface Query {
    queryName: string;
    queryKey: string;
}